import { jsx as _jsx } from "react/jsx-runtime";
import { StoreLocatorCard } from "../../../../components/StoreLocator";
import { useTranslations } from "../../../../providers/useTranslations";
import styles from "./StoreDetailsPopup.module.scss";
export const StoreDetailsPopup = ({ store, storeDetailsPage, onClose, isClosable = false, }) => {
    const { __ } = useTranslations();
    return (_jsx(StoreLocatorCard, { className: styles.card, onClose: onClose, isClosable: isClosable, isActive: false, store: store, storeDetailsPage: storeDetailsPage }));
};
//# sourceMappingURL=StoreDetailsPopup.js.map